import { createContext, useContext, useMemo, useState } from 'react';

import Unauthorized from '../components/Auth/Unauthorized';

type AuthProviderProps = {
  children: React.ReactElement;
};

type AuthGuardProps = {
  children: React.ReactElement;
};

export type AuthContextType = {
  isUnauthorized: boolean;
  setUnauthorized: (value: boolean) => void;
};

export const AuthContext = createContext<AuthContextType | null>(null);
export const useAuth = () => useContext(AuthContext);

const AuthGuard = ({ children }: AuthGuardProps) => {
  const auth = useContext(AuthContext);

  if (auth?.isUnauthorized) {
    return <Unauthorized />;
  }

  return children;
};

const AuthProvider = ({ children }: AuthProviderProps) => {
  const [isUnauthorized, setIsUnauthorized] = useState(false);

  const setUnauthorized = (value: boolean) => setIsUnauthorized(value);

  const value = useMemo(
    () => ({
      isUnauthorized,
      setUnauthorized
    }),
    [isUnauthorized]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export default AuthProvider;
export { AuthGuard };
